import React, {Component, ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import {ShopTableInterface} from 'app/interfaces/ShopTableInterface';
import ShopTableOtherItems from 'app/components/shop/ShopTableOtherItems';
import I18n from 'app/i18n';

@inject('shopStore')
@observer
export default class OtherItemsContainer extends Component<ShopTableInterface & {isSets?: boolean}> {
    render(): ReactNode {
        const {isSets, shopStore} = this.props;
        const {loading, data} = shopStore || {};
        const title = `${I18n.t('menu_links.shop')} - ${I18n.t(isSets ? 'shop.sets' : 'other')}`;
        const items = isSets ? data?.sets : data?.other_items;

        return <>
            <h1 className="visually-hidden-title">{title}</h1>
            {loading || !items
                ? <SmartFullPageLoader />
                : <ShopTableOtherItems {...this.props} />}
        </>;
    }
}

